import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=dd2e2bd8"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports